import { userApi } from "../../api";


//Actions
export function requestUserRegistration(regobj) {
    return async dispatch => {
    try {
    
        dispatch({ type: 'AUTH_CHK_LOADING', loading: true, error: '' });
        const apiResponse = await userApi.registration(regobj);
        const respJson = await apiResponse.json();
        if (apiResponse.status === 200) {
            dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: "" });
        } else {
            dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: respJson });
        }
    } catch (er) {
        let msg = er.toString();
        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: msg });
    }

    }
}

export function requestUserLogin(loginobj) {
    return async dispatch => {
    try {
       
        dispatch({ type: 'AUTH_CHK_LOADING', loading: true, error: '' });
        const apiResponse = await userApi.requestLogin(loginobj);
        const respJson = await apiResponse.json();
        if (apiResponse.status === 200) {           
            if(respJson.status){
                dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: "" });
            }else{
                dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: "Email send faild !" });
            }
           
        } else {
            dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: respJson });
        }
    } catch (er) {
        let msg = er.toString();
        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: msg });
    }

    }
}

export function userlogin_via_Link(userid, code) {
    return async dispatch => {
        try {
            let obj = {};
            obj['userid'] = userid;
            obj['code'] = code;

            /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
            obj['message'] = 'L_Loggedin';              
            localStorage.setItem('currentuserid',userid);  
            /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
 
            dispatch({ type: 'AUTH_RESET_ERROR' });
            if (obj.userid !== undefined && obj.code !== undefined) {
                dispatch({ type: 'AUTH_CHK_LOADING', loading: true, error: '' });
                const apiResponse = await userApi.loginViaLink(obj);
                const respJson = await apiResponse.json();
 
                if (apiResponse.status === 200) {
                    let jwt = respJson;
                    getUserDetails(dispatch, jwt)
                    await userApi.setUserActivitylog(obj);               /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
                } else {
                    if (respJson.code === "[jwt_auth] invalid_username") {
                        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: "Invalid username" });
                    } else if (respJson.code === "[jwt_auth] incorrect_password") {
                        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: "Invalid password" });
                    } else {
                        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: respJson });
                    }
                }

            } else {
                // throw new Error('Please provide email and valid code');
            }

        } catch (er) {

            let msg = er.toString();
            dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: msg });
        }
    }
}

export function validateusertoken(token) {
    return async dispatch => {
        try {
            if (token !== "") {
                dispatch({ type: 'AUTH_CHK_LOADING', loading: true, error: '' });
                const apiResponse = await userApi.validateToken(token);
                const respJson = await apiResponse.json();
                //console.log(respJson);
                if (apiResponse.status !== 200) {
                    dispatch({ type: 'AUTH_FAILD' });
                    dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: "Authentication Faild" });
                } else {
                    getUserDetails(dispatch, token)
                }
            }

        } catch (er) {
            // console.log(er);
            let msg = er.toString();
            dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: msg });
        }

    }
}

export async function getUserDetails(dispatch, jwt) {
    const apiResponse = await userApi.getUser(jwt);
    const respJson = await apiResponse.json();

    if (apiResponse.status === 200) {
        dispatch({
            type: 'AUTH_SET', user: respJson,
            token: jwt
        });
        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: '' });
    } else {
        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: 'your not authorized!' });
    }

}

export function logout() {
    return async dispatch => {

        /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
        let obj = {};                                   
        obj['userid']= localStorage['currentuserid'];  
        obj['message'] = 'L_Loggedout';                 
        await userApi.setUserActivitylog(obj);          
        /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
        localStorage.setItem('comingFrom','logout'); 
        
        dispatch({ type: 'AUTH_CHK_LOADING', loading: true, error: '' });
        dispatch({ type: 'AUTH_FAILD' });
        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: '' });
    }
}

export function logoutWithDispatch(dispatch) {

        dispatch({ type: 'AUTH_CHK_LOADING', loading: true, error: '' });
        dispatch({ type: 'AUTH_FAILD' });
        dispatch({ type: 'AUTH_CHK_LOADING', loading: false, error: '' });
    
}